import React from 'react'
import { Box, Typography } from '@mui/material'
import { observer } from 'mobx-react'

import { FormattedMessage } from 'react-intl'

const NoDataFound = ({ length, isLoaded }) => {
  return (
    <Box
      className={'jst-center'}
      width={1}
      p={4.5}
      sx={{ background: 'rgba(217, 217, 217, 0.20)' }}
    >
      <Typography
        sx={{ fontWeight: '500', color: '#A9A9A9', fontSize: '13px' }}
      >
        {!isLoaded && <FormattedMessage id={'загрузка..'} />}
        {!length && isLoaded && (
          <FormattedMessage id={'нет данных для отображения'} />
        )}
      </Typography>
    </Box>
  )
}

export default observer(NoDataFound)
